import { Input } from "reactstrap"
export default function InputField({ field, ...props }) {
    return (
        <Input
            {...field}
            {...props}
            className={`rounded-pill input-color ${props.form.errors[field.name] && props.form.touched[field.name] ? "input-error" : ""}`}
        />
    )
}